
export default {
  middleware: ['authentication'],
}
